import { createSelector } from '@reduxjs/toolkit';

import { selectContract } from 'shared/selectors/jsonQuery';

import { selectContractOptions } from './selectContractOptions';

const DEFAULT_LABEL = 'Тип договора';

export const selectContractLabel = createSelector([selectContract, selectContractOptions], (values, options) => {
  if (!values || values.length === 0) {
    return DEFAULT_LABEL;
  }

  const labels = values.map(value => options.find(opt => opt.value === value)?.label).filter(Boolean);

  if (labels.length === 0) {
    return DEFAULT_LABEL;
  }

  return labels.join(', ');
});
